import { DatePicker } from "antd";
import { PickerProps } from "antd/es/date-picker/generatePicker";
import caretRight from "assets/svg/CaretRightGray.svg";
import calendarBlank from "assets/svg/CalendarBlank.svg";
import styles from "./index.module.css";

export const DatePickerComponent = (data: PickerProps) => {
  return (
    <DatePicker
      {...data}
      classNames={{ popup: { root: styles.popup }, root: styles.datePickerNew }}
      suffixIcon={
        data?.suffixIcon ? data.suffixIcon : <img src={calendarBlank} alt="calendar img" width={15} height={16.25} />
      }
      nextIcon={<img src={caretRight} alt="carretright" />}
      format={data.format ?? "DD.MM.YYYY"}
      prevIcon={<img src={caretRight} alt="carretright" style={{ transform: "rotate(180deg)" }} />}
      locale={{
        monthFormat: "MMMM",
        timePickerLocale: {
          placeholder: "Select time",
        },
        lang: {
          locale: "en_US",
          placeholder: "Select date",
          now: "Now",
          backToToday: "Back to today",
          ok: "OK",
          clear: "Clear",
          month: "Month",
          year: "Year",
          timeSelect: "Select time",
          dateSelect: "Select date",
          monthSelect: "Choose a month",
          yearSelect: "Choose a year",
          decadeSelect: "Choose a decade",
          yearFormat: "YYYY",
          dateFormat: "M/D/YYYY",
          dayFormat: "D",
          dateTimeFormat: "M/D/YYYY HH:mm:ss",
          monthFormat: "MMMM",
          monthBeforeYear: true,
          previousMonth: "Previous month (PageUp)",
          nextMonth: "Next month (PageDown)",
          previousYear: "Last year (Control + left)",
          nextYear: "Next year (Control + right)",
          previousDecade: "Last decade",
          nextDecade: "Next decade",
          previousCentury: "Last century",
          nextCentury: "Next century",
          shortWeekDays: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
          week: "week",
        } as any,
      }}
    />
  );
};
